import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  Link,
  Spacer,
  TranslationProvider,
} from '@resy/ui-kitchen';

import Check from '../../../images/icons/checkmark-success.svg';

import './ReservationCanceled.scss';

const ReservationCanceled = ({
  closeModal, url, venue,
}) => (
  <div className="ReservationCanceled">
    <div className="ReservationCanceled__content">
      <Check width={63} height={63} />
      <TranslationProvider translationKey="reservation_canceled_title">
        <h1
          className="ReservationCanceled__content-title"
          role="alert"
        >
          Cancelled
        </h1>
      </TranslationProvider>
      <TranslationProvider
        translationKey="reservation_canceled_description"
        translationValues={{ venue }}
      >
        <p>
          {`Your reservation at ${venue} has been cancelled. Thanks for letting us know.`}
        </p>
      </TranslationProvider>
      <Spacer height={40} />
      <p>
        <TranslationProvider
          translationKey="reservation_canceled_book_another"
          translationValues={{ venue }}
        >
          <Link className="BookAnotherTableLink" href={url} onClick={closeModal}>
            {`Book another table at ${venue}?`}
          </Link>
        </TranslationProvider>
      </p>
    </div>
    <div className="ReservationCanceled__ctas">
      <TranslationProvider translationKey="reservation_canceled_button">
        <Button
          lg
          onClick={closeModal}
          data-test-id="reservation_canceled-button-done"
        >
          Done
        </Button>
      </TranslationProvider>
    </div>
  </div>
);

ReservationCanceled.propTypes = {
  closeModal: PropTypes.func,
  venue: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

ReservationCanceled.defaultProps = {
  closeModal: () => {},
};

export default ReservationCanceled;
